

export async function serverUrlFun () {
    return  window.location.origin+'/api'
}

export function setNavigationInfo(data){

    if(data.companyName) {
        document.title = data.companyName
        sessionStorage.setItem("companyName", data.companyName)
    }else{
        if(sessionStorage.getItem("companyName")){
            document.title = sessionStorage.getItem("companyName")
        }
    }
    if(data.loginStyle && data.loginStyle.iconBase64) {
        sessionStorage.removeItem("companyIconBase64")
        let $favicon = document.querySelector('link[rel="icon"]');
        $favicon.href =  'data:image/png;base64,'+data.loginStyle.iconBase64;
        sessionStorage.setItem("companyIconBase64", data.loginStyle.iconBase64)
    }else{
        sessionStorage.removeItem("companyIconBase64")
        if(sessionStorage.getItem("companyIconBase64")){
            let $favicon = document.querySelector('link[rel="icon"]');
            $favicon.href =  'data:image/png;base64,'+sessionStorage.getItem("companyIconBase64");
        }
    }
    if(data.companyLogoBase64) {
      sessionStorage.setItem("companyLogoBase64", data.companyLogoBase64)
    }
}



export function createCORS(method, url){
    var xhr = new XMLHttpRequest();
    if('withCredentials' in xhr){
        xhr.open(method, url, true);
    }else if(typeof XDomainRequest != 'undefined'){
        var xhr = new XDomainRequest();
        xhr.open(method, url);
    }else{
        xhr = null;
    }
    return xhr;
}

export function sendCorsRequest(url) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, false);
    xhr.withCredentials = true;
    xhr.onreadystatechange = function() {
        if(xhr.readyState == 4 && xhr.status == 200) {
            // alert(xhr.getResponseHeader("PHPSESSID"));
            // Get header from php server request if you want for something
            // var cookie = xhr.getResponseHeader("Cookie");
            // alert("Cookie:" + cookie);
        }
    }
    xhr.send();




    // var request = createCORS('get', url);
    // if(request){
    //     request.onload = function(){
    //
    //     };
    //     request.send();
    // }

}
